// extracted by mini-css-extract-plugin
export default {"icon":"notifications_icon__u0UE2","title":"notifications_title__fjeAT","date":"notifications_date__3qPf-"};